import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { MapPinned } from "lucide-react";

const MILES_TO_METERS = 1609.34;

export const ServiceAreaMiniMap = ({ preview, testId }) => {
  const elRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!elRef.current || !preview) return;
    let cancelled = false;
    let timer = null;
    const map = L.map(elRef.current, {
      attributionControl: false,
      zoomControl: false,
      dragging: false,
      scrollWheelZoom: false,
      doubleClickZoom: false,
      boxZoom: false,
      keyboard: false,
      touchZoom: false,
      tap: false,
      zoomAnimation: false,
      fadeAnimation: false,
      markerZoomAnimation: false,
    }).setView([39.5, -98.35], 3);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 18 }).addTo(map);
    mapRef.current = map;

    const safeFit = (bounds) => {
      timer = setTimeout(() => {
        if (cancelled || !mapRef.current) return;
        try {
          map.invalidateSize();
          if (bounds && bounds.isValid && bounds.isValid()) map.fitBounds(bounds, { padding: [4, 4], animate: false });
        } catch (e) { /* swallow leaflet race */ }
      }, 0);
    };

    if (preview.kind === "radius" && preview.center) {
      const [lng, lat] = preview.center;
      const circle = L.circle([lat, lng], { radius: (preview.radius_miles || 10) * MILES_TO_METERS, color: "#0052FF", weight: 1.5, fillOpacity: 0.2 }).addTo(map);
      safeFit(circle.getBounds());
    } else if (preview.geometry) {
      const gj = L.geoJSON(preview.geometry, { style: { color: "#0052FF", weight: 1.5, fillOpacity: 0.2 } }).addTo(map);
      const bounds = gj.getBounds();
      if (bounds.isValid()) safeFit(bounds);
    }

    return () => {
      cancelled = true;
      if (timer) clearTimeout(timer);
      try { map.remove(); } catch (e) { /* noop */ }
      mapRef.current = null;
    };
  }, [preview]);

  if (!preview) {
    return (
      <div data-testid={testId} className="flex h-24 w-32 shrink-0 items-center justify-center rounded-xl border border-dashed border-slate-200 bg-slate-50 dark:border-white/10 dark:bg-white/[0.03]">
        <MapPinned size={18} className="text-slate-300 dark:text-slate-600" />
      </div>
    );
  }

  return <div ref={elRef} data-testid={testId} className="h-24 w-32 shrink-0 rounded-xl border border-slate-200 dark:border-white/10" />;
};
